/** Apply Tokomoe platform branding (favicon/logo/title) to document head. */

export function applyPlatformFavicon(faviconUrl) {
  if (!faviconUrl || typeof document === 'undefined') return;

  const isPng = /\.png(\?|$)/i.test(faviconUrl);
  const type = isPng ? 'image/png' : 'image/x-icon';

  document.querySelectorAll("link[rel*='icon']").forEach((el) => el.remove());

  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = type;
  link.href = faviconUrl;
  document.head.appendChild(link);

  const apple = document.createElement('link');
  apple.rel = 'apple-touch-icon';
  apple.href = faviconUrl;
  document.head.appendChild(apple);
}

export function applyPlatformBranding({ name, faviconUrl, logoUrl, primaryColor } = {}) {
  if (faviconUrl) applyPlatformFavicon(faviconUrl);
  if (name && typeof document !== 'undefined') {
    const current = document.title || '';
    if (!current || /Tokomoe|TokoMoe|StarOrder/i.test(current)) {
      document.title = name;
    }
  }
  if (primaryColor && typeof document !== 'undefined') {
    let theme = document.querySelector('meta[name="theme-color"]');
    if (!theme) {
      theme = document.createElement('meta');
      theme.name = 'theme-color';
      document.head.appendChild(theme);
    }
    theme.content = primaryColor;
  }
  return { name, faviconUrl, logoUrl, primaryColor };
}
